module.exports = __webpack_public_path__ + "img/trash.cea93870.png";